import type from '../actions/types';
import { DocumentTypeState } from '../../models/interfaces';
import { ActionType } from '../../../../models/types';

const INITIAL_STATE: DocumentTypeState = {
  selectedDocumentType: {},
  listDocumentTypes: [],
  isLoading: true,
}

function reducer(state: DocumentTypeState = INITIAL_STATE, action: ActionType) {
  switch (action.type) {
    case type.SET_SELECTED_DOCUMENT_TYPE:
      return {
        ...state,
        selectedDocumentType: action.payload
      }; 
    case type.SET_LIST_DOCUMENTS_TYPES:
      return {
        ...state,
        listDocumentTypes: action.payload
      }; 
    case type.SET_LOADING_DOCUMENT_TYPES:
      return {
        ...state,
        isLoading: action.payload
      }; 
    default:
      return state;
  }
}

export default reducer;